<div class="container" *ngIf="!isLoading">
    <div class="header">
        <div class="back-button-container">
            <div *ngIf="vessel" class="back-button" data-cy="ops-settings-back-button" (click)="backButtonClick()">
                {{
                    'account-settings.back-button'
                        | translate
                            : {
                                  vesselName: vessel?.name,
                                  vesselNumber: vessel?.number,
                              }
                }}
            </div>
        </div>
        <h3 class="title" data-cy="ops-settings-page-header">
            {{ 'account-settings.title' | translate }}
        </h3>
    </div>
    <div class="ops-settings-main">
        <div class="side-menu">
            <div
                *ngFor="let tab of OPS_SETTING_TABS"
                class="tab"
                data-cy="ops-settings-side-menu-tabs"
                [class.selected]="selectedTab === tab"
                (click)="tabClick(tab)">
                {{ tab | translate }}
            </div>
        </div>
        <div class="ops-settings-content">
            <app-system-setting *ngIf="selectedTab === OPS_SYSTEM" [vessel]="vessel" [userCanEdit]="userCanEdit"> </app-system-setting>
            <app-ops-account *ngIf="selectedTab === USER_ACCOUNT" [vessel]="vessel" [userCanEdit]="userCanEdit"> </app-ops-account>
            <app-duty-engineer *ngIf="selectedTab === DUTY_ENGINEER && vessel" [vessel]="vessel" [userCanEdit]="userCanEdit"> </app-duty-engineer>
            <app-console-settings *ngIf="selectedTab === CONSOLE_SETTINGS" [vessel]="vessel" [userCanEdit]="userCanEdit"> </app-console-settings>
            <app-output-settings *ngIf="selectedTab === OUTPUT_SETTINGS" [vessel]="vessel" [userCanEdit]="userCanEdit"> </app-output-settings>
            <app-graphs *ngIf="selectedTab === GRAPHS" [vessel]="vessel" [userCanEdit]="userCanEdit"> </app-graphs>
            <app-external-comm-settings *ngIf="selectedTab === EXT_COMM_SETTINGS" [vessel]="vessel" [userCanEdit]="userCanEdit">
            </app-external-comm-settings>
            <app-system-color *ngIf="selectedTab === SYSTEM_COLOR" [vessel]="vessel" [userCanEdit]="userCanEdit"> </app-system-color>
            <app-eap-led-settings *ngIf="selectedTab === EAP_SETTINGS" [vessel]="vessel" [userCanEdit]="userCanEdit">
            </app-eap-led-settings>
        </div>
    </div>
</div>

<app-locked-vessel-notification
    [vessel]="vessel"
    [pageName]="'account-settings.title' | translate"></app-locked-vessel-notification>
